import jquery from 'jquery'

;(window as any).$ = jquery
;(window as any).jQuery = jquery
